const translations = {
  "en": {
    "MC/Vol": "MC/Vol",
    "Price": "Price"
  },
  "zh-tw": {
    "MC/Vol": "市值/交易量",
    "Price": "價格"
  }
};

export default translations;
